import React from 'react';
import AlertModal from '../AlertModal';

const QualiaSentConfirmModal = ({ show, updating, onConfirm, onCancel }) => (
  <AlertModal
    show={show}
    onHide={onCancel}
    onDismissClick={onCancel}
    onContinueClick={onConfirm}
    showProgress={updating}
    title="Sent in Qualia?"
    alertText="Confirm that you sent this message in the Qualia order inbox."
    continueButtonText="Sent in Qualia"
    continueButtonVariant="info"
    dismissButtonText="Cancel"
  />
);

export default QualiaSentConfirmModal;
